import styled from 'styled-components';

export const ComparePlanStyled = styled.div`
  .plan-table {
    border: 1px solid #e1e3e5;
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
  }

  .table-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    border-bottom: 1px solid #e1e3e5;

    &:last-child {
      border-bottom: none;
    }

    .icon-feature-check .Polaris-Icon__Svg {
      color: rgba(72, 176, 44, 1);
    }
  }

  .table-cell {
    padding: 16px;
    border-right: 1px solid #e1e3e5;

    &:last-child {
      border-right: none;
    }
  }

  .text-center {
    text-align: center;
  }

  .text-bold {
    font-weight: 700;
  }
`;
